import React from 'react'
import classNames from 'classnames'
import { graphql, useStaticQuery } from 'gatsby'
import ReactMarkdown from 'react-markdown'

import { TrainingPageQuery } from '../../types/graphql'

import { Layout } from '../../components/Layout'
import { SEO } from '../../components/SEO'

import circle from '../../images/training-circle.svg'
import pentagon from '../../images/training-pentagon.svg'
import triangle from '../../images/training-triangle.svg'

import * as classes from './training.module.scss'

const Training: React.FC = () => {
  const { allStrapiCourse, video } = useStaticQuery<TrainingPageQuery>(graphql`
    query TrainingPage {
      allStrapiCourse {
        nodes {
          description
          details {
            description
            id
            title
          }
          id
          link
          title
        }
      }
      
      video: file(name: { eq: "promo" }) {
        publicURL
      }
    }
  `)

  return (
    <Layout>
      <SEO title={'Training'} />

      <div className={classNames('container', classes.container)}>
        <div className={classes.main}>
          <h1>
            Poche conversioni? Ti aiutiamo a impostare la strategia corretta
          </h1>

          <video autoPlay className={classes.video} controls loop muted playsInline>
            <source src={video?.publicURL!} />
          </video>

          <h2>
            Scopri tutto ciò che ti serve per aumentare il traffico e le vendite
            online. Grazie ai nostri corsi imparerai a <strong>costruire un’efficace
            strategia di marketing digitale</strong>, produrre contenuti corretti e{' '}
            <strong>scegliere il migliore canale di vendita</strong> per il tuo business.
            <br />
            <br />
            Ogni percorso è composto da <strong>cinque incontri online</strong> per un <strong>max di 10
            partecipanti</strong> e da una <strong>consulenza one-to-one</strong>. Tutte le lezioni si
            svolgeranno su una piattaforma che ti permetterà di interagire con
            il docente e gli altri partecipanti al corso. Oltre all’attività
            teorica sono previste delle esercitazioni pratiche.
          </h2>

          <h3>
            <strong>CORSI ONLINE</strong> A PARTIRE DA SETTEMBRE 2020
          </h3>
        </div>

        <div className={classes.courses}>
          {allStrapiCourse.nodes.map((course, index) => (
            <div className={classes.course} key={course.id!}>
              <h2>
                0{index + 1}_<strong className={classes.uppercase}>{course.title}</strong>
              </h2>

              <ReactMarkdown>
                {course.description}
              </ReactMarkdown>

              {course.details?.map(detail => (
                <React.Fragment key={detail!.id!}>
                  <h3>{detail!.title}</h3>
                  <ReactMarkdown>
                    {detail!.description}
                  </ReactMarkdown>
                </React.Fragment>
              ))}

              <a
                className={classNames(classes.button, classes[`type${index}`])}
                href={course.link!}
                target={'_blank'}
                rel={'noreferrer noopener'}
              >
                Iscriviti
              </a>
            </div>
          ))}
        </div>

        <div className={classes.footer}>
          <p>
            per maggiori info scrivici a{' '}
            <a href={'mailto:info@btwofactory.com'}>
              <strong>info@btwofactory.com</strong>
            </a>
          </p>
        </div>

        <img className={classes.circle} src={circle} />
        <img className={classes.pentagon} src={pentagon} />
        <img className={classes.triangle} src={triangle} />
      </div>
    </Layout>
  )
}

export default Training
